import { FC } from "react";
import Heading from "components/Heading/Heading";
import MultiStockCard from "components/Quasi/MultiStockCard/MultiStockCard";
import Skeleton from "react-loading-skeleton";
import { useGetBorghiHighlightsQuery } from "application/features/borghi/borghiApiSlice";

export interface SectionSliderNewCategoriesProps {
  className?: string;
  itemClassName?: string;
  heading?: string;
  subHeading?: string;
  categoryCardType?: string;
  itemPerRow?: number;
  sliderStyle?: string;
  uniqueClassName?: string;
  categories?: any[];
}

const SectionSliderBorghi: FC<SectionSliderNewCategoriesProps> = ({
  heading = "Destinazioni più ricercate",
  subHeading = "Scopri le destinazioni più ricercate dalla nostra tribù di viaggiatori e smartworker",
  className = "",
  itemClassName = "",
}) => {
  const { data, isLoading } = useGetBorghiHighlightsQuery({});

  // Get borghi directly from highlights response
  const allBorghi = data?.borghi || [];

  const renderCard = (item: any, index: number) => {
    return (
      <MultiStockCard
        key={item.id || index}
        id={item.id || item.name || index}
        cover={item.cover || item.thumbnail || ""}
        title={item.name || item.id || "Destinazione"}
        href={"/borgo/" + (item.name || item.id || "")}
      />
    );
  };

  const renderCardSkeleton = () => (
    <div className="w-full">
      <Skeleton height={180} className="rounded-2xl" />
      <div className="mt-4 px-3 space-y-2">
        <Skeleton height={20} width="70%" />
        <Skeleton height={16} width="50%" />
      </div>
    </div>
  );

  if (!isLoading && allBorghi.length === 0) {
    return null;
  }

  return (
    <div className={`nc-SectionSliderNewCategories ${className}`}>
      <div className="flow-root">
        <Heading desc={subHeading} hasNextPrev={false} isCenter={true}>
          {heading}
        </Heading>

        {isLoading ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mt-12">
            {[...Array(4)].map((_, index) => (
              <div key={index}>{renderCardSkeleton()}</div>
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mt-12">
            {allBorghi.slice(0, 8).map((item: any, index: number) => renderCard(item, index))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SectionSliderBorghi;
